<template>
  <div :class="['m-money-message', `direction-${direction}`]">
    <el-avatar shape="square" icon="el-icon-user" @click.native="clickUser" :src="info.avatar"></el-avatar>
    <div class="info money">
      <div class="user">
        <p style="font-size: 13px; color: #5e5e5e;width: auto">
          <span @click="clickUser">{{ info.company }}</span>
        </p>
        <p style="font-size: 12px; color: #999;width: auto">
          <span @click="clickUser">{{ info.name }}</span>
        </p>
      </div>
      <div class="bubble" style="cursor: pointer;">
        <div class="tips" @click="openHandle">
          <span>
            <svg-icon name="hongbao" style="font-size: 9px;"></svg-icon>
            红包
          </span>
          <span>{{ info.time }}</span>
        </div>
        <div class="pre-box" @click="openHandle">
          <el-button v-for="item in info.ats" :key="item.at" type="text" style="padding: 0" @click.stop="clickUser">@{{ item.atName }}</el-button>
          <pre>{{ info.txt }}</pre>
        </div>
        <div class="image-box" v-if="info.imgs && info.imgs.length" :style="{ height: fold ? '70px' : 'auto', overflow: 'hidden' }">
          <div class="image" v-for="(item, index) in info.imgs" :key="index">
            <div v-if="index === 3 && info.imgs.length > 4 && fold" @click="fold = false" class="more-btn">
              <i class="el-icon-more"></i>
              共{{ info.imgs.length }}个
            </div>
            <el-image :class="[info.msgType === 3 && 'border']" :src="item" :preview-src-list="info.imgs">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
      </div>
      <div class="tool-box">
        <div class="left">
          <svg-icon name="at" title="@Ta" @click.native="clickBtnHandle('at')"></svg-icon>

          <svg-icon v-if="likeList.includes(info.msgId)" name="good-fill" title="点赞" style="fill: #ee7700"></svg-icon>
          <svg-icon name="good" title="点赞" v-else @click.native="clickBtnHandle('like')"></svg-icon>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Bus from "@/components/Bus";
export default {
  data() {
    return {
      fold: true,
      showWithdraw: false
    };
  },
  methods: {
    clickUser() {
      this.$router.push({
        path: "/user",
        query: {
          id: this.info.id
        }
      });
    },
    link(path, query) {
      this.$store.commit("setChatScroll");
      if (this.info.tags || (this.info.reply && path === "detail")) {
        this.$router.push({
          path: `/${path}`,
          query: {
            id: this.info.reply || this.info.msgId
          }
        });
      }
      this.$router.push({
        path: `/${path}`,
        query
      });
    },
    async clickBtnHandle(type) {
      if (type === "like") {
        this.$store.dispatch("like", this.info.msgId);
      }
      this.$emit("click-btn", { type, info: this.info });
    },
    openHandle() {
      Bus.$emit("openRedEnvelope", this.info);
    }
  },
  components: {},
  computed: {
    direction() {
      if (this.fixed) {
        return "left";
      }
      let direction = "left";
      if (this.$store.state.userId === this.info.id) {
        direction = "right";
      }
      return direction;
    },
    likeList() {
      return this.$store.state.likeList;
    }
  },
  props: {
    info: {},
    fixed: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  mounted() {}
};
</script>
<style lang="scss">
.m-money-message {
  display: flex;
  width: 100%;
  .el-tag {
    cursor: pointer;
  }
  > div {
    display: flex;
    flex-direction: column;
  }
  .el-avatar {
    flex-shrink: 0;
    cursor: pointer;
  }
  &.direction-right {
    justify-content: flex-end;
    .user {
      text-align: right;
    }
    .el-avatar {
      margin-left: 10px;
      order: 1;
    }
    .bubble {
      width: auto;
      min-width: 100%;
    }
  }
  &.direction-left {
    .el-avatar {
      margin-right: 10px;
    }
  }
  .recall-btn {
    position: absolute;
    right: 0;
    font-size: 12px;
  }
  .user {
    display: inline-block;
    color: #666;
    font-size: 12px;
    margin-bottom: 2px;
    span {
      cursor: pointer;
    }
  }
  .tips {
    display: flex;
    padding: 0px 8px;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #ffee19;
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
  }
  .info {
    max-width: 80%;
    min-width: 45%;
  }
  .money {
    $color: #d32f2f;
    .bubble {
      background: $color;
      color: #fff;
      .tips {
        background-color: $color;
      }
      &:after {
        display: none;
      }
    }
  }

  .bubble {
    position: relative;
    border-radius: 2px;
    box-shadow: 3px 3px 2px 0px rgba(0, 0, 0, 0.1);
    background: #fff;
    font-size: 14px;
    .pre-box {
      padding: 10px;
      display: block;
      .el-button {
        padding: 0;
        margin: 0;
        margin-right: 5px;
      }
    }
    .border {
      border: 1px solid #fff;
    }
    .image-box {
      margin: 0px 5px 10px 5px;
      display: flex;
      flex-wrap: wrap;
      width: 300px;
      /*padding: 0px 10px;*/
      .image {
        display: inline-block;
        position: relative;
        width: 60px;
        height: 60px;
        margin: 5px;
      }
      .more-btn {
        position: absolute;
        top: 0;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        background-color: black;
        color: white;
        opacity: 0.5;
      }
    }
    .el-image {
      margin-right: 5px;
      width: 60px;
      height: 60px;
    }
  }
  .tool-box {
    position: relative;
    display: flex;
    justify-content: space-between;
    .text-btn {
      cursor: pointer;
      margin-right: 10px;
      color: #909399;
      font-size: 12px;
    }
    svg {
      margin: 5px;
      cursor: pointer;
      font-size: 14px;
      fill: #ccc;
    }
  }
}
</style>
